export default [
  {
    path: "/device/wide-profile",
    name: "deviceWideProfile",
    component: () => import(
      /*webpackChunkName:'device'*/
      "@/views/device/DeviceWideProfile.vue"),
    meta: {},
  },
  {
    path: "/device/deep-profile",
    name: "deviceDeepProfile",
    component: () => import(
      /*webpackChunkName:'device'*/
      "@/views/device/DeviceDeepProfile.vue"),
    meta: {},
  },
  {
    path: "/device/wide-task-result",
    name: "deviceWideTaskResult",
    component: () => import(
      /*webpackChunkName:'device'*/
      "@/views/device/DeviceWideTaskResult.vue"),
    meta: {},
  },
  {
    path: "/device/deep-task-result",
    name: "deviceDeepTaskResult",
    component: () => import(
      /*webpackChunkName:'device'*/
      "@/views/device/DeviceDeepTaskResult.vue"),
    meta: {},
  },  
  {
    path: "/device/issues",
    name: "devicesIssues",
    component: () => import(
      /*webpackChunkName:'device'*/
      "@/views/device/DevicesIssues.vue"),
    meta: {},
  },
  {
    path: "/device",
    name: "device",
    component: () => import(
      /*webpackChunkName:'device'*/
      "@/views/device/Device.vue"),
    meta: {},
  },
  {
    path: "/device/search",
    name: "ipSearch",
    component: () => import(
      /*webpackChunkName:'IpSearch'*/
      "@/views/device/IpSearch.vue"),
    meta: {},
  },
  {
    path: "/scan-task",
    name: "deviceWideTask",
    component: () => import(
      /*webpackChunkName:'DeviceWideTask'*/
      "@/views/device/DeviceWideTask.vue"),
    meta: {},
  },
]